import React, { useState } from 'react';

interface PasswordPromptProps {
  onSuccess: () => void;
}

export const PasswordPrompt: React.FC<PasswordPromptProps> = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (password === 'CLEAR') {
      onSuccess();
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sand-50 to-sand-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white p-8 border-2 border-ink-200">
          <div className="text-center mb-8">
            <h1 className="text-4xl font-bold text-ink-900 mb-2">CLEAR</h1>
            <p className="text-sm text-ink-600 font-mono uppercase tracking-wider">
              Crisis Learning, Early-warning, Anticipation, and Response
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="password" className="block text-sm font-semibold text-ink-900 mb-2">
                Enter Password
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                className="w-full px-4 py-3 border-2 border-ink-200 focus:border-accent-500 focus:outline-none text-ink-900 transition-colors"
                placeholder="Enter password"
                autoFocus
              />
              {error && (
                <p className="mt-2 text-sm text-red-600">{error}</p>
              )}
            </div>

            <button
              type="submit"
              className="w-full bg-accent-500 text-white px-6 py-3 font-semibold hover:bg-accent-600 transition-colors"
            >
              Access Site
            </button>
          </form>

          <div className="mt-8 pt-6 border-t border-ink-200">
            <p className="text-xs text-ink-500 text-center">
              This site is password protected. Please contact your administrator for access.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
